import MainLayout from '@/common/components/layouts/MainLayout';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { otherDamagedSteperData } from '@/modules/adjusterReportModules/IncidentParticipants/data/otherDamagedSteper.data';
import { OtherDamagedInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/otherDamagedInfo/OtherDamagedInfo.type';
import { getDamagedUserInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedUserInformation/getDamagedUserInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="زیان‌دیده / مالک" header="closeHeader">
      <OtherDamagedInfo>{children}</OtherDamagedInfo>
    </MainLayout>
  );
};

const OtherDamagedInfo = ({ children }: PropsWithChildren) => {
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    getDamagedUserInformationQueryOptions(+id!, +damagedId!),
  );

  const methods = useForm<OtherDamagedInfoType>({
    mode: 'onChange',
  });
  useEffect(() => {
    if (data) {
      methods.reset({
        personal_information: {
          ...data?.personal_information,
          national_id: data.personal_information.owner_national_id,
        },

        contact_information: data?.contact_information,
      });
      setTimeout(() => {
        methods?.trigger('personal_information.birthdate');
      });
    }
  }, [data, methods]);

  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={otherDamagedSteperData} width="70%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">
        <FormProvider {...methods}>{children}</FormProvider>
      </Box>
    </>
  );
};
